import { Button, Card, Checkbox, Col, Flex, Form, Row, message } from "antd";
import styled from "styled-components";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useFormFields } from "../entity/lib/useFormFields";
import workFlowFields from "../entity/config/workflow-fields";
import stepsConfig from "../entity/config/steps-config";
import { useEffect, useState } from "react";
import ModalForm from "../entity/ui/ModalForm";
import useCreateWorkflow from "../entity/api/create-workflow";
import { useLocation } from "react-router-dom";
import usePoolList from "../entity/api/pool-list";
import useUpdatedFeilds from "../entity/lib/useUpdateFeilds";
import usePoolMembers from "../entity/api/pool-members";
import useUpdatedStepsFeilds from "../entity/lib/useUpdatedStepsFeilds";

export default function SmartForm() {
  const location = useLocation();
  const [workflowForm] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [formType, setFormType] = useState("");
  const [activeStepIndex, setActiveStepIndex] = useState(null);
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [stepCount, setStepCount] = useState(0);

  const { renderField } = useFormFields();
  const { mutate } = useCreateWorkflow();
  const { poolList } = usePoolList();
  const { poolMembers } = usePoolMembers({ poolId: 46 });

  const updatedFeilds = useUpdatedFeilds({
    workFlowFields,
    poolList,
    selectedFrequency,
    poolMembers,
  });

  const updatedStepsFeilds = useUpdatedStepsFeilds({
    stepsConfig,
    poolMembers,
  });

  const onFinish = (values) => {
    mutate(values, {
      onSuccess: () => {
        message.success("Workflow created successfully!");
        workflowForm.resetFields();
      },
      onError: (err) => {
        message.error("Failed to create workflow. Please try again.!");
        console.error("Error creating workflow:", err);
      },
    });
  };

  const showModal = (index, type) => {
    setActiveStepIndex(index);
    setOpen(true);
    setFormType(type);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    let { state } = location;

    const frequency = state?.frequency;
    if (state) {
      workflowForm.setFieldsValue({
        name: state?.name || state?.templateName,
        workflow_type_id: parseInt(state?.workflowType) || null,
        frequency: state?.frequency,
        interval: state?.interval,
      });
      setSelectedFrequency(frequency);
      message.success("Template imported successfully");
    }
    state = {};
  }, [location, workflowForm]);

  // const requestbody = {
  //   project_name: "test",
  //   project_description: "<p><br></p>",
  //   pool: 1,
  //   is_shared: false,
  //   project_startdate: "2025-04-29",
  //   project_enddate: "2025-04-30",
  //   project_tags: null,
  //   project_icon_url: null,
  //   project_teams: [
  //     {
  //       name: "last emember last",
  //       user_id: 329,
  //       designation: "test",
  //       is_owner: true,
  //     },
  //     { name: "hamza h", user_id: 142, designation: "hra", is_owner: false },
  //     {
  //       name: "gafoor ka dosth",
  //       user_id: 146,
  //       designation: "tester",
  //       is_owner: false,
  //     },
  //   ],
  // };
console.log(poolMembers);
  return (
    <Card>
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "preconditionForm") {
            const { workflowForm } = forms;
            const steps = workflowForm.getFieldValue("steps") || [];
            const updatedSteps = steps.map((step, index) => {
              if (index === activeStepIndex) {
                return {
                  ...step,
                  precondition: values.precondition,
                };
              }
              return step;
            });
            workflowForm.setFieldsValue({ steps: updatedSteps });
          }

          if (name === "taskForm") {
            const { workflowForm } = forms;
            const steps = workflowForm.getFieldValue("steps") || [];
            const updatedSteps = steps.map((step, index) => {
              if (index === activeStepIndex) {
                return {
                  ...step,
                  task: values,
                };
              }
              return step;
            });
            workflowForm.setFieldsValue({ steps: updatedSteps });
          }
          setOpen(false);
        }}
      >
        <Form
          layout="vertical"
          name="workflowForm"
          form={workflowForm}
          onFinish={onFinish}
          initialValues={{
            steps: [],
          }}
          onFieldsChange={(changedFields) => {
            const frequencyField = changedFields.find((field) =>
              field.name.includes("frequency")
            );
            if (frequencyField) {
              setSelectedFrequency(frequencyField.value);
            }
          }}
        >
          {/* Workflow Fields */}
          <Row gutter={[16, 16]}>
            {updatedFeilds.map((field) => (
              <Col span={8} key={field.name}>
                <Form.Item
                  label={field.label}
                  name={field.name}
                  rules={field.rules || []}
                  hidden={field.hidden}
                >
                  {renderField(field)}
                </Form.Item>
              </Col>
            ))}
          </Row>

          {/* Steps */}
          <Form.List name="steps">
            {(fields, { add, remove }) => {
              setStepCount(fields?.length);
              return (
                <StepsRow>
                  {fields.map((field, index) => (
                    <InnerCard
                      size="small"
                      title={`Step ${index + 1}`}
                      key={field.key}
                      extra={
                        <CloseOutlined onClick={() => remove(field.name)} />
                      }
                    >
                      <Row gutter={[16, 16]}>
                        {updatedStepsFeilds.map((stepField) => (
                          <Col span={8} key={stepField.name}>
                            <Form.Item
                              label={stepField.label}
                              name={[field.name, stepField.name]}
                              rules={stepField.rules || []}
                            >
                              {renderField(stepField)}
                            </Form.Item>
                          </Col>
                        ))}
                      </Row>
                      {/* Modal Form buttons */}
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <AddButton
                            added={
                              !!workflowForm.getFieldValue("steps")?.[
                                field.name
                              ]?.precondition
                            }
                            onClick={() =>
                              showModal(field.name, "precondition")
                            }
                            icon={<PlusOutlined />}
                          >
                            {workflowForm.getFieldValue("steps")?.[field.name]
                              ?.precondition
                              ? "Precondition Added"
                              : "Add Precondition"}
                          </AddButton>
                        </Col>
                      </Row>
                      {/* Task Form buttons */}
                      <StyledButtonRow gutter={[16, 16]}>
                        <Col span={8}>
                          <AddButton
                            added={
                              !!workflowForm.getFieldValue("steps")?.[
                                field.name
                              ]?.task
                            }
                            onClick={() => showModal(field.name, "task")}
                            icon={<PlusOutlined />}
                          >
                            {workflowForm.getFieldValue("steps")?.[field.name]
                              ?.precondition
                              ? "Task Added"
                              : "Add Task"}
                          </AddButton>
                        </Col>
                      </StyledButtonRow>
                    </InnerCard>
                  ))}
                  <StyledButton onClick={() => add({})} icon={<PlusOutlined />}>
                    Add Step
                  </StyledButton>
                </StepsRow>
              );
            }}
          </Form.List>

          {/* Template Checkbox */}
          <StyledCheckboxWrapper>
            <Form.Item name="isTemplate" valuePropName="checked">
              <Checkbox>
                Do you want to create this workflow as a reusable template?
              </Checkbox>
            </Form.Item>
          </StyledCheckboxWrapper>

          {/* Submit Button */}
          <Flex justify="end" style={{ marginTop: "16px" }}>
            <Form.Item>
              <Button htmlType="submit" type="primary">
                Create Workflow
              </Button>
            </Form.Item>
          </Flex>
        </Form>
        <ModalForm
          open={open}
          onCancel={hideModal}
          formType={formType}
          activeStepIndex={activeStepIndex}
          workflowForm={workflowForm}
          stepCount={stepCount?.length ?? 0}
          poolMembers={poolMembers}
          poolList={poolList}
        />
      </Form.Provider>
    </Card>
  );
}

const StyledButton = styled(Button)`
  background-color: #02374d;
  color: #facc11;
  border: none;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #012837 !important;
    color: #fabc10 !important;
  }
`;

const StepsRow = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

const InnerCard = styled(Card)`
  background-color: #f5f5f5;
`;

const StyledCheckboxWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
`;

const AddButton = styled(Button)`
  background-color: ${({ added }) => (added ? "#28a745" : "#ffffff")};
  color: ${({ added }) => (added ? "white" : "#02374d")};
  border: none;
  transition: background-color 0.3s ease, color 0.3s ease;
  width: 100%;

  &:hover {
    background-color: ${({ added }) =>
      added ? "#218838" : "#ffffff"} !important;
    color: ${({ added }) => (added ? "white" : "#fabc10")} !important;
  }
`;

const StyledButtonRow = styled(Row)`
  margin-top: 16px;
`;
